import React from 'react';

import { setApp, getApp } from '../../index';
import InvalidFeedback from '../Atoms/InvalidFeedback';
import { nameRegex } from '../../Utils/ValidationPatterns';

class TextField extends React.Component {

    constructor(props) {
        super(props);
        this.state = { value: '' };
    }

    valChange(event) {
        event.preventDefault();
        var newVal = event.target.value;
        this.setState({ value: newVal });

        // Prop name equals to key of state 
        setApp(this.props.name, newVal);

        // if (this.props.name === "promoCode") {
        //     var applyPromoButton = document.querySelector('.promoCodeButton');
        //     if (newVal === "") {
        //         setApp('blockPromo', false);
        //         setApp('promoCodeNeedValidate', false);
        //         applyPromoButton.disabled = true;
        //     } else {
        //         setApp('promoCodeNeedValidate', true);
        //         applyPromoButton.disabled = false;
        //     }
        // }
    }

    render() {

        // Load existing value (if any) for textbox
        var existingValue = getApp(this.props.name);

        let patternCheck;

        if (this.props.pattern !== "") {
            patternCheck = this.props.pattern;
        } else {
            patternCheck = nameRegex;
        }

        return (
            <div className="loanApp-form-field loanApp-text-field loanApp-text-field-morph">
                <input
                    type={this.props.type ? this.props.type : "text"}
                    name={this.props.name}
                    required={this.props.required}
                    className="loanApp-form-control"
                    onFocus={this.valChange.bind(this)}
                    onChange={this.valChange.bind(this)}
                    value={existingValue}
                    maxLength={this.props.maxLength ? this.props.maxLength : "1000"}
                    data-error={this.props.error ? this.props.error : "This field was entered incorrectly"}
                    pattern={patternCheck}
                    title={this.props.title ? this.props.title : "Please check this field and try again."}
                />
                <label htmlFor={this.props.name}>{this.props.label}</label>
                <InvalidFeedback feedback={this.props.feedback ? this.props.feedback : "invalid"} />
            </div>
        )
    }
}

export default TextField;